const trending = {
    users: [],
    busy: false,
    keyword: '',
    hasMore: true,
    total: 0
};

export default trending;
